import { apiFetch } from '@/api/apiFetch';
import { t } from '@/translations/i18n';
import { DTOToTemplate, templateToDTO } from '@/typescript/transformers/template';
import type { ITemplate } from '@/typescript/interfaces/ITemplate';
import type { ITemplateDTO } from '@/typescript/interfaces/ITemplateDTO';

async function getTemplate(productType: string, templateName: string): Promise<ITemplate> {
    const response = await apiFetch(`/templates/${productType}/${templateName}/`);
    if (!response.ok) {
        throw new Error(t('fetch_templates_error'));
    }

    const dto = (await response.json()) as ITemplateDTO;

    return DTOToTemplate(dto);
}

async function putTemplate(template: ITemplate) {
    const templateDTO = templateToDTO(template);
    const body = {
        projectJson: templateDTO.projectJson,
    };
    const response = await apiFetch(`/templates/${template.id}/`, {
        method: 'PUT',
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        throw new Error(t('save_template_error'));
    }
}

export { getTemplate, putTemplate };
